import React from "react";
import { X, Filter } from "lucide-react";

const FILTER_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "thisWeek", label: "This Week" },
  { value: "thisMonth", label: "This Month" },
  { value: "lastMonth", label: "Last Month" },
  { value: "thisQuarter", label: "This Quarter" },
  { value: "thisYear", label: "This Year" },
  { value: "custom", label: "Custom Range" },
];

export default function MISFilterDrawer({
  open,
  onClose,
  filters,
  setFilters,
  divisions = [],
  users = [],
  stages = [],
  industries = [],
  onApply,
  onReset,
  // resetData
}) {
  const updateField = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

const resetFilters = () => {
  const resetData = {
    filterType: "thisMonth",
    divisionId: "",
    userId: "",
    stageId: "",
    industryType: "",
    fromDate: "",
    toDate: "",
  };

  setFilters(resetData);

  onReset?.(resetData);
};

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/40 z-40 transition-all duration-300 ${
          open
            ? "opacity-100 visible"
            : "opacity-0 invisible"
        }`}
        onClick={onClose}
      />

      <div
        className={`fixed top-0 right-0 h-full bg-white z-50 shadow-2xl transition-all duration-300
        w-full sm:w-[400px] lg:w-[430px]
        ${open ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <div className="flex items-center gap-2">
            <Filter size={18} />
            <h2 className="text-lg font-semibold">
              MIS Filters
            </h2>
          </div>

          <button
            onClick={onClose}
            className="p-2 rounded-md hover:bg-gray-100"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 overflow-y-auto h-[calc(100%-140px)] space-y-5">

          {/* Filter Type */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Filter Type
            </label>

            <select
              value={filters.filterType}
              onChange={(e) =>
                updateField(
                  "filterType",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-3 py-2"
            >
              {FILTER_OPTIONS.map((item) => (
                <option
                  key={item.value}
                  value={item.value}
                >
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          {/* Custom Dates */}
          {filters.filterType === "custom" && (
            <>
              <div>
                <label className="block text-sm font-medium mb-2">
                  From Date
                </label>

                <input
                  type="date"
                  value={filters.fromDate}
                  onChange={(e) =>
                    updateField(
                      "fromDate",
                      e.target.value
                    )
                  }
                  className="w-full border rounded-lg px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  To Date
                </label>

                <input
                  type="date"
                  value={filters.toDate}
                  onChange={(e) =>
                    updateField(
                      "toDate",
                      e.target.value
                    )
                  }
                  className="w-full border rounded-lg px-3 py-2"
                />
              </div>
            </>
          )}

          {/* Division */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Division
            </label>

            <select
              value={filters.divisionId}
              onChange={(e) =>
                updateField(
                  "divisionId",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-3 py-2"
            >
              <option value="">
                All Divisions
              </option>

              {divisions.map((item) => (
                <option
                  key={item._id}
                  value={item._id}
                >
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* User */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Sales Person
            </label>

            <select
              value={filters.userId}
              onChange={(e) =>
                updateField(
                  "userId",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-3 py-2"
            >
              <option value="">
                All Users
              </option>

              {users.map((item) => (
                <option
                  key={item._id}
                  value={item._id}
                >
                  {item.firstName}{" "}
                  {item.lastName}
                </option>
              ))}
            </select>
          </div>

          {/* Stage */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Stage
            </label>

            <select
              value={filters.stageId}
              onChange={(e) =>
                updateField(
                  "stageId",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-3 py-2"
            >
              <option value="">
                All Stages
              </option>

              {stages.map((item) => (
                <option
                  key={item._id}
                  value={item._id}
                >
                  {item.stageName}
                </option>
              ))}
            </select>
          </div>

          {/* Industry */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Industry
            </label>

            <select
              value={filters.industryType}
              onChange={(e) =>
                updateField(
                  "industryType",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-3 py-2"
            >
              <option value="">
                All Industries
              </option>

              {industries.map((item) => (
                <option
                  key={item}
                  value={item}
                >
                  {item}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 border-t bg-white p-4 flex gap-3">
          <button
            onClick={resetFilters}
            className="flex-1 border rounded-lg py-2 font-medium"
          >
            Reset
          </button>

          <button
            onClick={onApply}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white rounded-lg py-2 font-medium"
          >
            Apply Filters
          </button>
        </div>
      </div>
    </>
  );
}